export const dataSetsProps = {
  borderWidth: 0.7,
  borderColor: '#000',
  backgroundColor: 'transparent',
};



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/LabTestHistoryModal/consts/graphSettings.js